export enum fingerStates {
    notStarted = 'notStarted',
    inProgress = 'inProgress',
    completed = 'completed',
    error = 'error',
}